module.exports = __webpack_public_path__ + "static/media/0297_Small.aea88fd3.jpg";